import Navbar from './Components/Navbar/Navbar';
import Signup from "./Components/SignInUp/Signup";
import Login from './Components/SignInUp/Login';
import Footer from './Components/Footer/Footer';
import Home from './Components/Home/Home';
import About from './Components/About/About';
import Contact from './Components/Contact/Contact';
import sunImg from './Images/sun.png'
import moon from './Images/moon.png'
import showEye from './Images/showEye.png'
import hideEye from './Images/hideEye.jpeg'
import React, { useEffect, useState } from 'react';
import { Routes, Route } from "react-router-dom";
import './App.css';
import "./Components/Tests/Test.css"
import HTMLtest from './Components/Tests/HTMLtest';
import CSStest from './Components/Tests/CSStest';
import JStest from './Components/Tests/JStest';
import JAVAtest from './Components/Tests/JAVAtest';
import MYSQLtest from './Components/Tests/MYSQLtest';
import CPPtest from './Components/Tests/CPPtest';
import TRAINtest from './Components/Tests/TRAINtest';
import PERCENTAGEtest from './Components/Tests/PERCENTAGEtest';
import AVERAGEStest from './Components/Tests/AVERAGEStest';
import CODINGdECODINGtest from './Components/Tests/CODINGdECODINGtest';
import MISSINGTERMtest from './Components/Tests/MISSINGTERMtest';
import CALENDERtest from './Components/Tests/CALENDERtest';
import HISTORYtest from './Components/Tests/HISTORYtest';
import GEOGRAPHYtest from './Components/Tests/GEOGRAPHYtest';
import INDIANPOLITICStest from './Components/Tests/INDIANPOLITICStest';
import CURRENTAFFAIRStest from './Components/Tests/CURRENTAFFAIRStest';
import WORLDWARStest from './Components/Tests/WORLDWARStest';
import MARATHItest from './Components/Tests/MARATHItest';

function App() {
  let [mode, setMode] = useState('bright');
  let [imgSrc, setImgSrc] = useState(moon)

  let changeMode = () => {
    if (mode === 'dark') {
      setMode('bright')
    }
    else {
      setMode('dark')
    }
  }

  useEffect(() => {
    setImgSrc(mode === 'bright' ? moon : sunImg);
  }, [mode])

  let [eyeSrc, seteyeSrc] = useState(showEye)
  let [passType, setpassType] = useState('password')
  let changeEye = () => {
    if (eyeSrc === showEye) {
      seteyeSrc(hideEye)
      setpassType('text')
    }
    else {
      seteyeSrc(showEye)
      setpassType('password')
    }
  }
  let preventPaste = (e) => {
    e.preventDefault()
    alert('Copy paste in password section is not allowed')
  }
  return (
    <>
      <Navbar mode={mode} changeMode={changeMode} imgSrc={imgSrc} />
      <Routes>
        <Route path='/' element={<Signup mode={mode} passType={passType} preventPaste={preventPaste} eyeSrc={eyeSrc} changeEye={changeEye} />} />
        <Route path='/login' element={<Login mode={mode} passType={passType} preventPaste={preventPaste} eyeSrc={eyeSrc} changeEye={changeEye} />} />
        <Route path='/home' element={<Home mode={mode} />} />
        <Route path='/about' element={<About mode={mode} />} />
        <Route path='/contact' element={<Contact mode={mode} />} />
        <Route path='/html' element={<HTMLtest mode={mode} />} />
        <Route path='/css' element={<CSStest mode={mode} />} />
        <Route path='/js' element={<JStest mode={mode} />} />
        <Route path='/java' element={<JAVAtest mode={mode} />} />
        <Route path='/mysql' element={<MYSQLtest mode={mode} />} />
        <Route path='/cpp' element={<CPPtest mode={mode} />} />
        <Route path='/trainProblem' element={<TRAINtest mode={mode} />} />
        <Route path='/percentage' element={<PERCENTAGEtest mode={mode} />} />
        <Route path='/averages' element={<AVERAGEStest mode={mode} />} />
        <Route path='/codingDecoding' element={<CODINGdECODINGtest mode={mode} />} />
        <Route path='/missingTerm' element={<MISSINGTERMtest mode={mode} />} />
        <Route path='/calender' element={<CALENDERtest mode={mode} />} />
        <Route path='/history' element={<HISTORYtest mode={mode} />} />
        <Route path='/geography' element={<GEOGRAPHYtest mode={mode} />} />
        <Route path='/IndianPolitics' element={<INDIANPOLITICStest mode={mode} />} />
        <Route path='/currentAffairs' element={<CURRENTAFFAIRStest mode={mode} />} />
        <Route path='/worldWars' element={<WORLDWARStest mode={mode} />} />
        <Route path='/marathi' element={<MARATHItest mode={mode} />} />
      </Routes>
      <Footer mode={mode} />

    </>
  );
}

export default App;
